
import { defineComponent } from "vue";
import SettlementEntityIndexList from "@/components/page/kyc/settlement-entity/IndexList.vue";

export default defineComponent({
  name: "settlement-entity-natural-person",
  components: {
    SettlementEntityIndexList,
  },
  setup() {
    return {};
  },
});
